export default function AboutSection() {
  return (
    <section
      id="about"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-10">
          {/* Left: Image */}
          <div className="w-full lg:w-2/5">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20modern%20editorial%20workspace%20with%20multiple%20digital%20screens%20displaying%20entertainment%20news%20content%2C%20soft%20coral%20and%20warm%20cream%20color%20palette%2C%20clean%20minimalist%20desk%20setup%2C%20natural%20lighting%20from%20side%20window%2C%20cozy%20atmosphere%2C%20professional%20content%20creation%20environment%2C%20no%20people%20visible&width=800&height=600&seq=about-brand-01&orientation=landscape"
                alt="今日大瓜品牌形象"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>

          {/* Right: Text */}
          <div className="w-full lg:w-3/5 flex flex-col gap-3">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              关于今日大瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              <strong className="text-foreground-900">今日大瓜</strong>成立于2024年，是国内领先的娱乐热点与热点大瓜追踪平台。
              我们致力于为爱吃瓜、爱八卦、关注娱乐圈动态的用户提供最及时、最全面的热点吃瓜资讯。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              平台覆盖明星动态、影视综艺、音乐演出、网红事件等多个领域，通过智能追踪与人工精选相结合的方式，
              确保每一条娱乐大瓜都经过验证，让用户在轻松愉快的氛围中掌握娱乐圈的第一手热点爆料。
              每日更新超过200条内容，已成为数百万吃瓜爱好者的每日必访之地。
            </p>
            <div className="flex flex-wrap gap-4 mt-2">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500">200+</span>
                <span className="text-sm text-foreground-600">日均更新</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-500">50+</span>
                <span className="text-sm text-foreground-600">资讯来源</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500">100万+</span>
                <span className="text-sm text-foreground-600">月活用户</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}